<script type="ts">
  export let values: {
    wallet:              string,
		competitionScore:    number,
		compRewardsTotal:    number,
		overallRewardsTotal: number,
  }[];
  export let activeUser: string;
  
  // console.log(values);
  // : {
  //   challengeScores:    string[],
  //   competitionScores:  string[],
  //   stakingRewards:     string[],
  //   challengeRewards:   string[],
  //   competitionRewards: string[],
  //   overallRewards:     string[]
  // };
</script>

<div class="flex flex-col">
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
      <div class="shadow overflow-hidden border-b border-gray-200 rounded-md">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="px-4 py-3 text-right text-xs font-medium text-gray-500 tracking-wider">
                <!-- Ranking -->
              </th>
              <th scope="col" class="px-4 py-3 text-right text-xs font-medium text-gray-500 tracking-wider">
                Wallet
              </th>
              <th scope="col" class="px-4 py-3 text-right text-xs font-medium text-gray-500 tracking-wider">
                Challenges Participated
              </th>
              <th scope="col" class="px-4 py-3 text-right text-xs font-medium text-gray-500 tracking-wider">
                Avg Stake
              </th>
              <th scope="col" class="px-4 py-3 text-right text-xs font-medium text-gray-500 tracking-wider">
                Total Earned
              </th>
              <th scope="col" class="px-4 py-3 text-right text-xs font-medium text-gray-500 tracking-wider">
                Avg Gain (%)
              </th>
<!--              <th scope="col" class="px-4 py-3 text-right text-xs font-medium text-gray-500 tracking-wider">-->
<!--                Gain s.d.-->
<!--              </th>-->
<!--              <th scope="col" class="px-4 py-3 text-right text-xs font-medium text-gray-500 tracking-wider">-->
<!--                Net YIEDL Earned-->
<!--              </th>-->

              <!-- <th scope="col" class="relative px-6 py-3">
                <span class="sr-only">Edit</span>
              </th> -->
            </tr>
          </thead>
          <tbody>
            <!-- Odd row -->
            {#each values as competitor, i}
              <tr class="bg-white tabular-nums text-right"
                  class:bg-gray-50={i % 2 && competitor.addrBack.toLowerCase() !== activeUser.substring(35).toLowerCase()}
                  class:bg-yellow-200={competitor.addrBack.toLowerCase() === activeUser.substring(35).toLowerCase()}>
                <td class="pl-6 pr-4 py-4 whitespace-nowrap text-xs font-medium text-gray-900">
                  {i + 1}
                </td>
                <td class="px-4 py-4 whitespace-nowrap text-xs text-gray-500">
                  {`0x` + `${competitor.addrFront.substring(0, 3)}...${competitor.addrBack.substring(11)}`}
                </td>
                <td class="px-4 py-4 whitespace-nowrap text-xs text-gray-500">
                  {competitor.challenges}
                </td>
                <td class="px-4 py-4 whitespace-nowrap text-xs text-gray-500">
                  {competitor.avgStake.toFixed(2)}
                </td>
                <td class="px-4 py-4 whitespace-nowrap text-xs text-gray-500">
                  {competitor.totalEarned.toFixed(2)}
                </td>
                <td class="px-4 py-4 whitespace-nowrap text-xs text-gray-500">
                  {(100 * competitor.avgGain).toFixed(2)}
                </td>
<!--                <td class="px-4 py-4 whitespace-nowrap text-xs text-gray-500">-->
<!--                  {competitor.stdDevGain.toFixed(2)}-->
<!--                </td>-->
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
